import { render, staticRenderFns } from "./EducationTypeAdd.vue?vue&type=template&id=8f83b6e4&"
import script from "./EducationTypeAdd.vue?vue&type=script&lang=js&"
export * from "./EducationTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports